{
  "data": {
    "themes": {
      "a": {
        "Dark": {
          "1": "#0d9b78",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#0d5442",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#0d9b78",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#edf8fb",
          "22": "#82ead4",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4b",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#4b4b4b",
          "34": "#121212",
          "35": "#02d09e",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#0d9b78",
          "2": "#0d9b78",
          "3": "#edf8fb",
          "4": "#82ead4",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#0d9b78",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#edf8fb",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#edf8fb",
          "22": "#82ead4",
          "23": "#edfdfd",
          "24": "#a4e3da",
          "25": "#0d9b78",
          "26": "#5f636c",
          "27": "#82ead4",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#0d9b78",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#4b4b4b",
          "34": "#f9f9f9",
          "35": "#0d9b78",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#098968"
        }
      },
      "b": {
        "Dark": {
          "1": "#956141",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#58341d",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#956141",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#fedfcd",
          "22": "#ffd2b9",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4b",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#a57450",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#956141",
          "2": "#956141",
          "3": "#fff7f2",
          "4": "#c9aa98",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#956141",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#fff0e7",
          "16": "#323238",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#fedfcd",
          "22": "#ffc09d",
          "23": "#ffdfcf",
          "24": "#ffd1a4",
          "25": "#956141",
          "26": "#5f636c",
          "27": "#ffbf97",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#956141",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f3",
          "34": "#f9f9f9",
          "35": "#956141",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#874822"
        }
      },
      "c": {
        "Dark": {
          "1": "#485faa",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#2b3d79",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#485faa",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#f2fffc",
          "22": "#b2c4ff",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4b",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#a2b5e5",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#485faa",
          "2": "#485faa",
          "3": "#f2f5ff",
          "4": "#acc0ff",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#485faa",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#eaefff",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#f2fffc",
          "22": "#b2c4fe",
          "23": "#d8e1ff",
          "24": "#b6c7ff",
          "25": "#485faa",
          "26": "#5f636c",
          "27": "#b2c4ff",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#485faa",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#485faa",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#3c539b"
        }
      },
      "d": {
        "Dark": {
          "1": "#5f7830",
          "2": "#ffffff",
          "3": "#4e5465",
          "4": "#3e4e1e",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5465",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#5f7830",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5465",
          "19": "#4e5465",
          "20": "#ffdbc3",
          "21": "#eaffc4",
          "22": "#eaffc4",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4b",
          "31": "#4e5465",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#aac080",
          "36": "#4e5465",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#5f7830",
          "2": "#5f7830",
          "3": "#fafff2",
          "4": "#cbe89a",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#5f7830",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#f6ffe6",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#eaffc4",
          "22": "#c0d992",
          "23": "#dcff9c",
          "24": "#eaffc4",
          "25": "#5f7830",
          "26": "#5f636c",
          "27": "#9baa7b",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#5f7830",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#607d29",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#526e1f"
        }
      },
      "e": {
        "Dark": {
          "1": "#b18c3a",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#593f03",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#b18c3a",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#f2fffc",
          "22": "#dcbc79",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4c",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#dbbe7d",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#b18c3a",
          "2": "#b18c3a",
          "3": "#fff9ea",
          "4": "#d1bf9b",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#b18c3a",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#fff8e7",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#f2fffc",
          "22": "#dcbc79",
          "23": "#fde8bc",
          "24": "#fde8bf",
          "25": "#b18c3a",
          "26": "#5f636c",
          "27": "#fde8bd",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#b18c3a",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#af8a38",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#a37f30"
        }
      },
      "f": {
        "Dark": {
          "1": "#5a868d",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#2d5257",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#5a868d",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#9fbabf",
          "22": "#add8df",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4c",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#a2c3c6",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#5a868d",
          "2": "#5a868d",
          "3": "#f0fdff",
          "4": "#acc6ca",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#5a868d",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#edfdff",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#9fbabf",
          "22": "#acd8df",
          "23": "#c1f3fe",
          "24": "#789396",
          "25": "#5a868d",
          "26": "#5f636c",
          "27": "#a1bdc0",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#5a868d",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#4c7f87",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#54787e"
        }
      },
      "g": {
        "Dark": {
          "1": "#a65c8a",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#512641",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#a65c8a",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#ffeef9",
          "22": "#ffd2ef",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4c",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#c08bae",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#a65c8a",
          "2": "#a65c8a",
          "3": "#fff4fb",
          "4": "#f8bde3",
          "5": "#ffffff",
          "6": "#f6f6f6",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#a65c8a",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#fff0f9",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#ffeef9",
          "22": "#ffd2ef",
          "23": "#ffe7f6",
          "24": "#ffcaee",
          "25": "#a65c8a",
          "26": "#5f636c",
          "27": "#ffd0f1",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#b06092",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#a65c8a",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#97527d"
        }
      },
      "h": {
        "Dark": {
          "1": "#8d6edb",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#704ec5",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#8d6edb",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#efe8ff",
          "22": "#c6b0ff",
          "23": "#949c9b",
          "24": "#a4e3da",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc4",
          "29": "#949c9b",
          "30": "#4b4b4b",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#af97e6",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#8d6edb",
          "2": "#8d6edb",
          "3": "#f0eaff",
          "4": "#c8b2ff",
          "5": "#ffffff",
          "6": "#f2f2f2",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#8d6edb",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#f2ecff",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#efe8ff",
          "22": "#c6b0ff",
          "23": "#e7deff",
          "24": "#a4e3da",
          "25": "#8d6edb",
          "26": "#5f636d",
          "27": "#cfbdfe",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#8d6edb",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#825edd",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#697076"
        }
      },
      "i": {
        "Dark": {
          "1": "#91a071",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#798462",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#91a071",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#f2fffc",
          "22": "#c2ccac",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc4",
          "29": "#949c9b",
          "30": "#4b4b4c",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#aab597",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#91a071",
          "2": "#91a071",
          "3": "#f8ffed",
          "4": "#c8d0b6",
          "5": "#ffffff",
          "6": "#f2f2f2",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#91a071",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#f9ffed",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#f2fffc",
          "22": "#c2ccac",
          "23": "#c2ccad",
          "24": "#b7c699",
          "25": "#91a071",
          "26": "#5f636c",
          "27": "#c2ccaf",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#91a071",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#718451",
          "36": "#949c9f",
          "37": "#e8f7fd",
          "38": "#829066"
        }
      },
      "j": {
        "Dark": {
          "1": "#667697",
          "2": "#ffffff",
          "3": "#4e5464",
          "4": "#49515f",
          "5": "#1a1c23",
          "6": "#121212",
          "7": "#b1b4b5",
          "8": "#ffffff",
          "9": "#4e5464",
          "10": "#4b4b4b",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.7)",
          "14": "#ff6700",
          "15": "#667697",
          "16": "#22252e",
          "17": "#949c9b",
          "18": "#4e5464",
          "19": "#4e5464",
          "20": "#ffdbc3",
          "21": "#a0aabf",
          "22": "#a0aabe",
          "23": "#949c9b",
          "24": "#ffffff",
          "25": "#4a4f5e",
          "26": "#5f636c",
          "27": "#949c9b",
          "28": "#ffdbc3",
          "29": "#949c9b",
          "30": "#4b4b4b",
          "31": "#4e5464",
          "32": "#ffe5e5",
          "33": "#1e1e1e",
          "34": "#121212",
          "35": "#9dadc9",
          "36": "#4e5464",
          "37": "#0f3451",
          "38": "#5f6678"
        },
        "Light": {
          "1": "#667697",
          "2": "#667697",
          "3": "#f3f7ff",
          "4": "#a8b1c4",
          "5": "#ffffff",
          "6": "#f2f2f2",
          "7": "#757d7f",
          "8": "#323238",
          "9": "#667697",
          "10": "#e5e5e5",
          "11": "#f34643",
          "12": "#ffffff",
          "13": "rgba(0, 0, 1, 0.4)",
          "14": "#ff6700",
          "15": "#f5f8ff",
          "16": "#323239",
          "17": "#ffffff",
          "18": "#f2f2f3",
          "19": "#32323a",
          "20": "#ff6700",
          "21": "#a0aabf",
          "22": "#a0aabe",
          "23": "#b6cdff",
          "24": "#a4c2ff",
          "25": "#667697",
          "26": "#5f636c",
          "27": "#c9dbff",
          "28": "#ffdbc3",
          "29": "#5e626c",
          "30": "#667697",
          "31": "#ffffff",
          "32": "#ffe5e5",
          "33": "#f2f2f4",
          "34": "#f9f9f9",
          "35": "#667697",
          "36": "#949c9b",
          "37": "#e8f7fd",
          "38": "#5a6885"
        }
      }
    },
    "defaultUserTheme": "a",
    "defaultFigmaTheme": "a",
    "defaultUserMode": "Dark",
    "defaultFigmaMode": "Dark"
  }
}